export enum Convenio {
  PARTICULAR = 'PARTICULAR',
  CONVENIOS = 'CONVENIOS',
  SUS = 'SUS',
}

export const CONVENIO_FILTER_ALL = 'All'
export const CONVENIO_FILTER_CONVENIOS_OU_PARTICULAR = 'CONVENIOS_OU_PARTICULAR'
export type ConvenioFilter =
  | typeof CONVENIO_FILTER_ALL
  | typeof CONVENIO_FILTER_CONVENIOS_OU_PARTICULAR
  | Convenio.SUS

/**
 * PAGO - Tudo que tem o título baixado ou seja de fato pago.
 * PENDENTE - Tudo que gerou repasse, mas o setor de repasse médico não mexeu ainda. (FORA DE REPASSE)
 * PROCESSANDO - Tudo que está DENTRO DE REPASSE Aberto ou DENTRO de Repasse Fechado sem título
 * LIBERADO - Tudo que está DENTRO DE REPASSE Fechado, mas só não foi dado baixa no título
 */
export enum TransferStatus {
  PAGO = 'PAGO',
  LIBERADO = 'LIBERADO',
  PROCESSANDO = 'PROCESSANDO',
  PENDENTE = 'PENDENTE',
  GLOSADO = 'Glosado',
}

export type Transfer = {
  hospitalTransferId: string
  numeroAtendimento: number | null
  numeroRepasseTerceiro: number | null
  status: string
  descricaoProcedimento: string | null
  observacaoRepasse: string | null
  valorProcedimento: number
  valorRepasse: number
  convenio: Convenio | null
  descricaoConvenio: string | null
  descricaoStatus: string | null
  dataProcedimento: string
  dataAlta: string
  dataProtocolo: string
  dataFechamentoRepasse: string | null
  dataPagamento: string | null
  dataContabil: string
  classeDoTitulo?: string | null
  statusGlosaTituloReceber?: string | null
}

/** Atendimento particular (sem convênio), para relatório/UI. */
export function isParticularTransfer(transfer: Transfer): boolean {
  return transfer.convenio === Convenio.PARTICULAR
}
